import angular from 'angular';
import uiRouter from 'angular-ui-router';
import quoteComponent from './quote.component';
import procedureComponent from './procedure/procedure.component';
import itemComponent from './item/item.component';

let quoteModule = angular.module('quote', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newQuote', {
            url: '/quotes/new',
            component: 'quote',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                procedureTemplates: (ProcedureTemplatesService) => {
                    return ProcedureTemplatesService.find({
                        filter: {
                            include: 'itemTemplates'
                        }
                    });
                },
                itemTemplates: (ItemTemplatesService) => {
                    return ItemTemplatesService.find();
                },
                user: (LoginService) => LoginService.getCurrent()
            }
        })
        .state('editQuote', {
            url: '/quotes/:id?editing&operativeSpendingId',
            component: 'quote',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                quote: (
                    QuotesService,
                    OperativeSpendingsService,
                    $stateParams
                ) => {
                    return QuotesService.findById($stateParams.id, {
                        include: [
                            'client',
                            'holder',
                            'vehicle',
                            'createdByUser',
                            'updatedByUser',
                            {
                                relation: 'operativeSpendings',
                                scope: {
                                    where: {
                                        associatedAt: {
                                            neq: null
                                        }
                                    }
                                }

                            },
                            {
                                relation: 'procedures',
                                scope: {
                                    include: [{
                                        relation: 'items',
                                        scope: {
                                            include: [{
                                                relation: 'osItems',
                                                scope: {
                                                    include: [
                                                        'operativeSpending'
                                                    ]
                                                }
                                            }]
                                        }
                                    }]
                                }
                            },
                            {
                                relation: 'receipts',
                                scope: {
                                    include: [
                                        'collection',
                                        {
                                            relation: 'receiptQuotes',
                                            scope: {
                                                where: {
                                                    quoteId: $stateParams.id
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ]
                    }).then(quote => {
                        return OperativeSpendingsService.find({
                            filter: {
                                where: {
                                    and: [{
                                        or: [{
                                            quoteId: quote.id
                                        }, {
                                            vehicleId: quote.vehicleId
                                        }, {
                                            holderId: quote.holderId
                                        }]
                                    }, {
                                        associatedAt: null
                                    }]
                                }
                            }
                        }).then(oSpendings => {
                            quote.pendingOperativeSpendings = oSpendings;
                            return quote;
                        });
                    });
                },
                procedureTemplates: (ProcedureTemplatesService) => {
                    return ProcedureTemplatesService.find({
                        filter: {
                            include: ['itemTemplates', 'children']
                        }
                    });
                },
                itemTemplates: (ItemTemplatesService) => {
                    return ItemTemplatesService.find();
                },
                user: (LoginService) => LoginService.getCurrent(),
                associatingSpending: (
                    OperativeSpendingsService, $stateParams
                ) => {
                    if ($stateParams.operativeSpendingId) {
                        return OperativeSpendingsService.findById(
                            $stateParams.operativeSpendingId
                        ).then(oSpending => {
                            if (oSpending.associatedAt) {
                                return null;
                            } else {
                                return oSpending;
                            }
                        });
                    }
                }
            }
        });
})
    .component('quote', quoteComponent)
    .component('quoteProcedure', procedureComponent)
    .component('quoteItem', itemComponent)
    .name;

export default quoteModule;
